export default __webpack_public_path__ + "static/media/user.935f59dd.svg";